import { FC } from 'react'

import clsx from 'clsx'

import styles from './OtpSlot.module.scss'
import { OtpSlotProps } from './OtpSlot.types'

export const OtpSlot: FC<OtpSlotProps> = ({
  char,
  hasFakeCaret,
  isActive,
  isLoading,
  hasError,
  className
}) => {
  return (
    <div
      className={clsx(styles.slot, className, {
        [styles.active]: isActive,
        [styles.loading]: isLoading,
        [styles.error]: hasError
      })}
    >
      <span>{char}</span>
      {hasFakeCaret && <div className={styles.caret} />}
    </div>
  )
}
